import { useContext, useEffect, useState } from "react";
import { MdHistory } from "react-icons/md";
import { api } from "../../..";
import { useNavigate, useParams } from "react-router-dom";
import { intToTime } from "../../../Components/Global";
import moment from "moment";
import Spinner from "../../../Components/Spinner/Spinner";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { PusherContext } from "../../../PusherContextProvider";

const History = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [queueCdr, setQueueCdr] = useState([]);
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(true);
	const { t } = useTranslation();
	const pusher = useContext(PusherContext)

	useEffect(() => {
		if(api.isLoggedIn()) {
			fetchData(id);

			if(api.accessToken && pusher) {
				pusher.pushOnMessageListener('QueueCdr', () => {
					fetchData(id);
				})
			}

		} else {
			navigate("/login");
		}
		// eslint-disable-next-line
	}, []);

	const fetchData = (id:any) => {
		if(id) {
			const user = api.getUser();
			api.calls.queue.cdr.browse(id)
			.then((r: any) => {
				setLoading(false);
				setQueueCdr(r.data);
			});


			api.calls.company.user.browse(user.pbx_company_id, true)
			.then((r: any) => setUsers(r.data));
		} else {
			toast.error('Unable to get data.');
		}
	}

	if(loading) {
		return <div className="callout">
			<div className="history">
				<span className='spinner-container'>
					<Spinner />
				</span>
			</div>
		</div>
	}

	return <div className="callout">
		<div className="history">
			<div className="row">
				<div className="small-9 medium-9 large-9 columns">
					<b>{t('call_history_today')}</b>
				</div>
				<div className="small-3 medium-3 large-3 columns">
					{
						<MdHistory
							className="history-icon"
							title={t('history_statistics')}
							onClick={() => {
								navigate(`/collaborative/history/statistics/${id}`);
							}}
						/>
					}
				</div>
			</div>
			<div className="row history-data">
				<div className="small-12 medium-12 large-12 columns">
					<table className="unstriped">
						<thead>
							<tr>
								<th>
									<b>{t('number')}</b>
								</th>
								<th>
									<b>{t('wait')}</b>
								</th>
								<th>
									<b>{t('call_time')}</b>
								</th>
								<th>
									<b>{t('answered_by')}</b>
								</th>
								<th>
									<b>{t('time')}</b>
								</th>
							</tr>
						</thead>
						<tbody>
							{
								Object.keys(queueCdr).length !== 0 && Object.keys(users).length !== 0
								?
									queueCdr.map((queue: any) => {
										return <tr key={queue.id}>
											<td>
												{
													<span
														className="dial-number"
														title={t('call')}
														onClick={() => {
															window.open(`tel: ${queue.callerid}`);
													}}>
														{ queue.callerid }
													</span>
												}
											</td>
											<td>
												{
													queue.wait_time !== null
													?
														intToTime(parseInt(queue.wait_time))
													:
														'00:00'
												}
											</td>
											<td>
												{
													queue.talk_time !== null
													?
														intToTime(parseInt(queue.talk_time))
													:
													'00:00'
												}
											</td>
											<td>
												{
													queue.pbx_user_id !== null
													?
														users.map((user:any) => {
															if( user.id === queue.pbx_user_id ) {
																return `${user.name} ${user.surname}`;
															}
														})
													:
													<span className="abandoned">{t('abandoned')}</span>
												}
											</td>
											<td>
												{ moment(queue.calldate).format('YYYY-MM-DD HH:mm:ss')?? '00:00' }
											</td>
										</tr>
									})
								:
									<tr>
										<td className="center-text" colSpan={5}>{t('no_data_found')}</td>
									</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
}

export default History;
